// extracted by mini-css-extract-plugin
export default {"wrapper":"Subscribed_wrapper__4P-v+","headerLogo":"Subscribed_headerLogo__MpYL6","main":"Subscribed_main__xUY+8"};